// extracted by mini-css-extract-plugin
module.exports = {"punk":"Punk_punk__2Sra1"};